import {createAction} from "@reduxjs/toolkit";

// Reset Reducer whose name is passed inside an array
export const resetReducers = createAction('resetReducers');
// Reset All the Reducer
export const resetAllReducers = createAction('resetAllReducers');
